export default __webpack_public_path__ + "static/media/american-express.725e5d65.svg";